<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>我的销售</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-top-15" >
      <el-card class="box-card">
        <el-button type="primary" @click="batchSwitch" v-if="status == 0">批量结算</el-button>

          <el-button type="primary" @click="select_order(0)" >未结算</el-button>
          <el-button  type="info"  @click="select_order(1)" >已结算</el-button>
      </el-card>
    </div>

    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>
      <el-table-column prop="oid" label="订单号"> </el-table-column>

      <el-table-column prop="level" label="创建日期">
        <template slot-scope="scope">
          {{ scope.row.created_time }}
        </template>
      </el-table-column>

      <el-table-column prop="totalprice" label="利润">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
      </el-table-column>

      <el-table-column prop="totalprice" label="下单人">
        <template slot-scope="scope">
          {{ scope.row.buyer_name }}
        </template>
      </el-table-column>
      <el-table-column prop="agent" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0"> 未结算 </span>
          <span v-if="scope.row.status == 1"> 结算 </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="7">
              <el-button size="mini" @click="orderDetail(scope.row)">查看</el-button>
            </el-col>
            <el-col :span="7">
              <el-button
                type="primary"
                size="mini"
                @click="handleUpdate(scope.$index, scope.row)"
                v-if="status == 0"
                >结算</el-button
              >
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      formInline: {
        oid: "",
        status: 0,
      },

      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      agent: false,
      product_stock: {},
      dialog_msg_visible: false,
      dialog_restore_visible: false,
      page: 1,
      user_id: 0,
      status:"all"
    };
  },
  methods: {
    ...mapActions({
      getOrderProfitsDataAction: "getOrderProfitsDataAction",

      orderProfitsSettlementAction: "orderProfitsSettlementAction",
    }),
    handleUpdate(index, row) {
      console.log(row);
      this.toggleSelection([row]);

      //alert(row['id']);
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    //批量设置
    batchSwitch() {
      const len = this.multipleSelection.length;
      if (len == 0) {
        this.$message.error("请选择订单");
        return;
      }

      let ids = [];
      this.multipleSelection.forEach((ele) => ids.push(ele.id));

      this.orderProfitsSettlementAction({ ids: JSON.stringify(ids) });
    },


    orderDetail(row) {
      const oid = row.oid;

      this.$router.push({
        name: "order_profits_detail",
        params: {
          oid: oid,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    select_order(index){
        this.page=1
        this.status=index
        this.getPageData()
    },
    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;

      this.getOrderProfitsDataAction({ page: page, status: this.status });
    },
    getPageData() {

      this.getOrderProfitsDataAction({
        page: this.page,

        status: this.status,
      });
    },
  },
  created() {
    // this.getOrderProfitsDataAction({ page: this.page });


  },

  mounted() {
    this.getPageData();
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.order_profits.result,
  }),

  watch: {
    // $route(to, from) {
    //   //监听路由是否变化
    //   if (to.params.status != from.params.status && to.params.status != null) {
    //     //status不为空才请求数据
    //     this.status = to.params.status;
    //     this.getPageData(); //调接口，请求数据
    //   }
    // },
    tableData(newdata) {
      if (newdata.code == 301) {
        this.page = 1;
        this.getPageData();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.dialog-footer {
  text-align: center;
  background-color: gainsboro;
  padding: 0.3rem;
}
</style>
